import type { SVGDynamicIconCustomColor, SentimentClass } from 'types';

export const SENTIMENT_CLASS_NEGATIVE: SentimentClass = 'negative';
export const SENTIMENT_CLASS_NEUTRAL: SentimentClass = 'neutral';
export const SENTIMENT_CLASS_POSITIVE: SentimentClass = 'positive';

export const SENTIMENT_CLASSES = [
  SENTIMENT_CLASS_NEGATIVE,
  SENTIMENT_CLASS_NEUTRAL,
  SENTIMENT_CLASS_POSITIVE
];

export const SENTIMENT_CLASS_COLORS: Record<SentimentClass, SVGDynamicIconCustomColor> = {
  [SENTIMENT_CLASS_NEGATIVE]: 'red',
  [SENTIMENT_CLASS_NEUTRAL]: 'orange',
  [SENTIMENT_CLASS_POSITIVE]: 'primary'
};
